import { render, staticRenderFns } from "./quilleditor.vue?vue&type=template&id=cf8b743a"
import script from "./quilleditor.vue?vue&type=script&lang=js"
export * from "./quilleditor.vue?vue&type=script&lang=js"
import style0 from "./quilleditor.vue?vue&type=style&index=0&id=cf8b743a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports